module.exports = __webpack_public_path__ + "img/error.8da3204e.svg";